import React from 'react';
import abs_negative from '../images/icons/abs_negative.png';
import abs_positive from '../images/icons/abs_positive.png';
import accident_free_positive from '../images/icons/accident_free_positive.png';
import accident_free_negative from '../images/icons/accident_free_negative.png';
import not_wrecked_positive from '../images/icons/not_wrecked_positive.png';
import not_wrecked_negative from '../images/icons/not_wrecked_negative.png';
import defects_positive from '../images/icons/defects_positive.png';
import defects_negative from '../images/icons/defects_negative.png';
import rental_negative from '../images/icons/rental_negative.png';
import rental_positive from '../images/icons/rental_positive.png';
import './Icons.scss';


const icons = (whichIcon, style) => {
  const icon = {
    // alert icons
    defects_description: <i className="material-icons danger-icon">error_outline</i>,
    import_description: <i className="material-icons">room</i>,
    rental_description: <i className="material-icons">directions</i>,
    // default icons
    clear: <i className="material-icons">clear</i>,
    done: <i className="material-icons">done</i>,
    accessories_description: <i className="material-icons">library_add</i>,
    arrow_right: <i className="material-icons arrow-icon">keyboard_arrow_right</i>,
    arrow_left: <i className="material-icons arrow-icon">keyboard_arrow_left</i>,
    upload: <i className="material-icons">file_upload</i>,
    delete: <i className="material-icons">delete</i>,
    bets_input: <i className="material-icons">toll</i>,
    arrow_drop_desc: <i className="material-icons sort-icon">arrow_drop_down</i>,
    arrow_drop_asc: <i className="material-icons sort-icon">arrow_drop_up</i>,
    chat: <i className="material-icons conversations-icon">chat_bubble</i>,
    comments: <i className="material-icons">comment</i>,
    delivery: <i className="material-icons">local_shipping</i>,
    check: <i className="material-icons">check</i>,
    abs_negative: <img alt="" className={style} src={abs_negative} />,
    abs_positive: <img alt="" className={style} src={abs_positive} />,
    accident_free_positive: <img alt="" className={style} src={accident_free_positive} />,
    accident_free_negative: <img alt="" className={style} src={accident_free_negative} />,
    not_wrecked_positive: <img alt="" className={style} src={not_wrecked_positive} />,
    not_wrecked_negative: <img alt="" className={style} src={not_wrecked_negative} />,
    defects_positive: <img alt="" className={style} src={defects_positive} />,
    defects_negative: <img alt="" className={style} src={defects_negative} />,
    rental_positive: <img alt="" className={style} src={rental_positive} />,
    rental_negative: <img alt="" className={style} src={rental_negative} />,
    original_lacquer_positive: <i style={{ color: '#7bc73f', }} className={`material-icons ${style}`}>invert_colors</i>,
    original_lacquer_negative: <i style={{ color: '#898695', }} className={`material-icons ${style}`}>invert_colors</i>,
    service_booklet_positive: <i style={{ color: '#7bc73f', }} className={`material-icons ${style}`}>chrome_reader_mode</i>,
    service_booklet_negative: <i style={{ color: '#898695', }} className={`material-icons ${style}`}>chrome_reader_mode</i>,
    import_vehicle_positive: <i style={{ color: '#7bc73f', }} className={`material-icons ${style}`}>directions_boat</i>,
    import_vehicle_negative: <i style={{ color: '#898695', }} className={`material-icons ${style}`}>directions_boat</i>,
    financed_vehicle_positive: <i style={{ color: '#7bc73f', }} className={`material-icons ${style}`}>euro_symbol</i>,
    financed_vehicle_negative: <i style={{ color: '#898695', }} className={`material-icons ${style}`}>euro_symbol</i>,
    vat_deducted_negative: <i style={{ color: '#898695', }} className={`material-icons ${style}`}>calculate</i>,
    vat_deducted_positive: <i style={{ color: '#7bc73f', }} className={`material-icons ${style}`}>calculate</i>,

    vin: <i style={{ color: '#7bc73f', }} className={`material-icons ${style}`}>receipt</i>,
  };
  return icon[whichIcon];
};

export default icons;
